"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
// Export a function to create a new Client instance
function createClient(..._args) {
    throw new Error('Only available in node context');
}
exports.createClient = createClient;
